import { useAtom } from "jotai";
import { homePinsAtom } from "./atoms";
import { getPinIcon } from "../../../utils/maps";
import { Venue } from "../../../types/venue";

export function useHomeVenues() {
  const [{ data, error, isLoading, isFetching }] = useAtom(homePinsAtom);
  const locations =
    data?.locations.map((e: Venue) => {
      if (e.venuePinType) return e;
      return {
        ...e,
        venuePinType: getPinIcon(e),
      };
    }) || [];
  return {
    locations,
    newRegion: data?.newRegion,
    error,
    isLoading,
    isFetching,
    newLocation: data?.newLocation,
  };
}
